import React, { useEffect, useState, Fragment } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Button, Row, Col, Input, Divider, Tooltip, FormInstance } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { IPV4Verify, IPV6Verify, MacVerify, MaskVerify } from "../../../../Utility/RegExp";
import { useAppSelector, useAppDispatch } from "store/hook";
import { setStaticIPCount, setIPv4Disabled, setIPv4MaskDisabled } from "../../store/topologySlice";
import { BsFileEarmarkBreak } from "react-icons/bs";

const { Option } = Select;

interface LANProps {
  SubmitConfigonFinish: (arg: any) => void;
  form: FormInstance<any>;
}

const BulkConfigFLan = React.memo(({ SubmitConfigonFinish, form }: LANProps) => {
  const { formData, deviceNum, importSource, staticIPCount, IPv4Disabled, IPv4MaskDisabled } = useAppSelector(
    (state) => state.topology
  );
  const disp = useAppDispatch();
  const [LANIPV6Static, setLANIPV6Static] = useState("");

  useEffect(() => {
    // console.log(form.getFieldValue('StaticIP'))
    const staticIPlength = form.getFieldValue("StaticIP")?.length;
    disp(setStaticIPCount(staticIPlength));
  }, [form.getFieldValue("StaticIP")]);

  useEffect(() => {
    setLANIPV6Static(formData.lan?.ipv6?.type || "delegate-prefix-from-wan");
    disp(setIPv4Disabled(false));
    disp(setIPv4MaskDisabled(false));
    if (importSource === "NewConfig") {
      return;
    }

    form.setFieldsValue({
      LAN_ipv4_address: formData?.lan?.ipv4?.address,
      StaticIP: formData?.lan?.ipv4?.dhcp?.pool?.[0]?.fixed_ip,
      LAN_ipv4_netmask: formData?.lan?.ipv4?.netmask,
      LAN_ipv4_dhcpmode: formData?.lan?.ipv4?.dhcp?.mode || "off",
      LAN_ipv4_dhcp_start: formData?.lan?.ipv4?.dhcp?.pool[0].start,
      LAN_ipv4_dhcp_end: formData?.lan?.ipv4?.dhcp?.pool[0].end,
      LAN_ipv6_type: formData?.lan?.ipv6?.type || "delegate-prefix-from-wan",
      LAN_ipv6_adress: formData?.lan?.ipv6?.static?.address,
      LAN_ipv6_assignment: formData?.lan?.ipv6?.dhcp?.assigment || "stateful",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
      <div className="formwrap">
        <Row gutter={24} justify="space-around">
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
            <h2>IPv4</h2>
            <Divider className={styles.divider} />
            <Row gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_address"}
                  label={<span style={IPv4Disabled ? { textDecoration: " line-through" } : {}}>IP Address</span>}
                  rules={[
                    {
                      required: IPv4Disabled ? false : true,
                      message: "required!",
                    },
                    IPV4Verify,
                  ]}
                >
                  <Input
                    disabled={IPv4Disabled}
                    placeholder={"192.0.0.0"}
                    maxLength={30}
                    addonAfter={
                      <Tooltip title="Exclude this field">
                        <BsFileEarmarkBreak onClick={() => disp(setIPv4Disabled(!IPv4Disabled))} />
                      </Tooltip>
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_netmask"}
                  label={<span style={IPv4MaskDisabled ? { textDecoration: " line-through" } : {}}>IP Mask</span>}
                  rules={[
                    {
                      required: IPv4MaskDisabled ? false : true,
                      message: "required!",
                    },
                    MaskVerify,
                  ]}
                >
                  {/* setIPv4MaskDisabled */}
                  <Input
                    disabled={IPv4MaskDisabled}
                    placeholder="255.255.255.0"
                    maxLength={30}
                    addonAfter={
                      <Tooltip title="Exclude this field">
                        <BsFileEarmarkBreak onClick={() => disp(setIPv4MaskDisabled(!IPv4MaskDisabled))} />
                      </Tooltip>
                    }
                  />
                </Form.Item>
              </Col>
              <h3>DHCP Server Configuration</h3>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_dhcpmode"}
                  label="DHCP Server"
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                  ]}
                  initialValue={"off"}
                  tooltip={"Enable to make router can lease IP address to DHCP clients which connect to LAN."}
                >
                  <Select placeholder="ON/OFF">
                    <Option key={0} value={"on"}>
                      ON
                    </Option>
                    <Option key={1} value={"off"}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_dhcp_start"}
                  label="IP Address Pool (From)"
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                    IPV4Verify,
                  ]}
                >
                  <Input placeholder="192.0.0.0" maxLength={30} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_dhcp_end"}
                  label="IP Address Pool (To)"
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                    IPV4Verify,
                  ]}
                >
                  <Input placeholder="192.0.0.0" maxLength={30} />
                </Form.Item>
              </Col>

              {deviceNum.length <= 1 && (
                <Form.List name="StaticIP">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map((field) => (
                        <Row gutter={24} key={field.key} style={{ marginLeft: "0px", width: "100%" }}>
                          <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                            <Form.Item
                              {...field}
                              name={[field.name, "enabled"]}
                              // fieldKey={[field.fieldKey, "enabled"]}
                              label="Statistic"
                              style={{ minWidth: "100px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "required!",
                                },
                              ]}
                            >
                              <Select placeholder={"ON/OFF"}>
                                {/* @ts-ignore */}
                                <Option key={0} value={true}>
                                  ON
                                </Option>
                                {/* @ts-ignore */}
                                <Option key={1} value={false}>
                                  OFF
                                </Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                            <Form.Item
                              {...field}
                              name={[field.name, "mac"]}
                              // fieldKey={[field.fieldKey, "mac"]}
                              label="MAC"
                              rules={[MacVerify]}
                            >
                              <Input placeholder="aa:bb:cc:dd:ee:ff" maxLength={30} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                            <Form.Item
                              {...field}
                              name={[field.name, "ip"]}
                              // fieldKey={[field.fieldKey, "ip"]}
                              label="IP"
                              rules={[IPV4Verify]}
                            >
                              <Input placeholder="0.0.0.0" maxLength={30} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={24} xl={2} className="mb-2">
                            <Button
                              danger
                              ghost
                              block
                              type="text"
                              icon={<MinusCircleOutlined />}
                              onClick={() => {
                                disp(setStaticIPCount(form.getFieldValue("StaticIP")?.length));
                                remove(field.name);
                              }}
                            ></Button>
                          </Col>
                        </Row>
                      ))}
                      <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item>
                          <Button
                            type="dashed"
                            disabled={deviceNum.length > 1 || staticIPCount === 16}
                            onClick={() => {
                              disp(setStaticIPCount(form.getFieldValue("StaticIP")?.length));
                              add();
                            }}
                            block
                            icon={<PlusOutlined />}
                          >
                            Add Static IP
                          </Button>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Form.List>
              )}
            </Row>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
            <h2>IPv6</h2>
            <Divider className={styles.divider} />
            <Form.Item
              name={"LAN_ipv6_type"}
              label="Type"
              rules={[
                {
                  required: true,
                  message: "required!",
                },
              ]}
              initialValue={"delegate-prefix-from-wan"}
              tooltip={
                <Fragment>
                  {" "}
                  <p>
                    Delegate Prefix from WAN: Automatically obtain an IPv6 network prefix from the service provider or
                    an uplink router.
                  </p>{" "}
                  <p>Static: Configure a fixed IPv6 address for the cellular router.</p>{" "}
                </Fragment>
              }
            >
              <Select
                onChange={(value: string) => {
                  setLANIPV6Static(value);
                  form.validateFields(["LAN_ipv6_adress"]);
                }}
                placeholder="Delegate/Static"
              >
                <Option key={0} value={"delegate-prefix-from-wan"}>
                  Delegate Prefix from WAN
                </Option>
                <Option key={1} value={"static"}>
                  Static
                </Option>
              </Select>
            </Form.Item>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv6_adress"}
                  label="Static Address"
                  rules={[
                    {
                      required: LANIPV6Static === "static",
                      message: "required!",
                    },
                    IPV6Verify,
                  ]}
                >
                  <Input disabled={LANIPV6Static !== "static"} placeholder="2001::1" maxLength={50} />
                </Form.Item>
              </Col>
            </Row>
            {/* )} */}
            <h3>DHCP Server Configuration</h3>
            <Form.Item
              name={"LAN_ipv6_assignment"}
              label="Address Assign"
              rules={[
                {
                  required: true,
                  message: "required!",
                },
              ]}
              initialValue={"stateful"}
              tooltip={
                <Fragment>
                  {" "}
                  <p>
                    Stateless: The cellular router uses IPv6 stateless auto configuration. RADVD (Router Advertisement
                    Daemon) is enabled to have the cellular router send IPv6 prefix information in router advertisements
                    periodically and in response to router solicitations.
                  </p>{" "}
                  <p>
                    Stateful: The cellular router uses IPv6 stateful auto configuration. The LAN IPv6 clients can obtain
                    IPv6 addresses through DHCPv6.
                  </p>{" "}
                </Fragment>
              }
            >
              <Select placeholder={"Stateful/Stateless"}>
                <Option key={0} value={"stateful"}>
                  Stateful
                </Option>
                <Option key={1} value={"stateless"}>
                  Stateless
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  );
});

export default BulkConfigFLan;

////////////////////////////////////////////////////////

export const assemble = (values: any, IPv4MaskDisabled: boolean, IPv4Disabled: boolean) => {
  let ipv6Obj: any = {
    type: values.LAN_ipv6_type,
    dhcp: { assigment: values.LAN_ipv6_assignment },
  };
  if (values.LAN_ipv6_type === "static") {
    ipv6Obj.static = { address: values.LAN_ipv6_adress };
  }

  let LanJSON: any = {
    ipv4: {
      dhcp: {
        mode: values.LAN_ipv4_dhcpmode,
        pool: [
          {
            start: values.LAN_ipv4_dhcp_start,
            end: values.LAN_ipv4_dhcp_end,
            fixed_ip: values.StaticIP || [],
          },
        ],
      },
    },
    ipv6: ipv6Obj,
  };

  if (!IPv4Disabled) {
    LanJSON.ipv4.address = values.LAN_ipv4_address;
  }

  if (!IPv4MaskDisabled) {
    LanJSON.ipv4.netmask = values.LAN_ipv4_netmask;
  }

  return LanJSON;
};
